export const offersBG = {
  "shippingTitle": "БЕЗПЛАТНА ДОСТАВКА",
  "shippingText1": "За поръчки над ",
  "shippingText2": "€ безплатна доставка!",
  "cashTitle": "НАЛОЖЕН ПЛАТЕЖ",
  "cashText": "Безплатен наложен платеж!",
  "topSellers": "НАЙ-ПРОДАВАНИ"
}